import React, { useState } from "react";
import success from "../../../src/waitlistDocVault/assets/images/success.png";
import failure from "../../../src/waitlistDocVault/assets/images/failure.png";
import verification from "../../../src/waitlistDocVault/assets/images/Verification.png";
import { Button, Col } from "reactstrap";
import { get } from "lodash";
import { ToastContainer } from "react-toastify";
import { setAnalyticsEvent } from "../../core/helpers/analytics";
// import { Mixpanel } from "../../waitlist/components/MixPanel";

export default function KycDematPreview(props) {
  const { setReupload } = props;
  const [errors, setErrors] = useState(props.errors);

  const getDematStatus = () => {
    if (props.isKycDone) {
      return <>
        <p className="mb-0">
          Demat verified successfully
        </p>
        <img src={success} alt="success-icon"/>
      </>
    } 
    if (errors.length) {
      return <>
        <p className="mb-0">
          Demat verification failed
        </p>
        <img src={failure} alt="failure-icon"/>
      </>
    } 
    if (!errors.length) {
      return <>
        <p className="mb-0">
          Demat verification is under process
        </p>
        <img src={verification} alt="success-icon"/>
      </>
    }
  }

  const editDemat = () => {
    setAnalyticsEvent(window.location.pathname + window.location.hash,
      "Postlogin_orobonds_docvault_Demat_Edit_Clicked"
    );
    // Mixpanel.track("cl_edit_demat_docvault");
    setReupload(true)
  }

  const dematNext = () => {
    /* Mixpanel.track("cl_next_demat_docvault",
      {
        "Email id": props.email ? props.email : ""
      }
    ); */
    props.moveNextTab();
  }

  return (
    <>
      <div className="demat-window">
      <div className="demat-status text-capitalize">        
        {getDematStatus()}      
      </div>

      { errors.length ? 
        <div className="banner mt-3 d-flex">
          <p>{get(props, "errors.0.remarks", "")}</p>
          {/* <span class="mdi mdi-close-circle-outline" /> */}
        </div> : null}

      <div className="demat-details border">
        <div className="demat-name-number">
          <Col lg={3}>
            <p>Demat</p>
          </Col>
          <Col lg={9}>
            <p>{props.userProfile && props.userProfile.demat}</p>
          </Col>
        </div>
        <div className="demat-name-number">
          <Col lg={3}>
            <p>DP Name</p>
          </Col>
          <Col lg={9}>
            <p>{props.userProfile && props.userProfile.dpName ? props.userProfile.dpName : '-'}</p>
          </Col>
        </div>
        <div className="btn-container mt-3">
          {!props.isKycDone && (
            <div className="submit" onClick={editDemat}>
              <Button color="secondary" outline>Edit</Button>
            </div>
          )}
          <Button
            className="nxt"
            onClick={dematNext}
            disabled={errors.length}
          >
            Next
          </Button>
        </div>
      </div>
    </div>
    <ToastContainer />
    </>
  );
}
